import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

export interface ExportResponse {
  data: Record<string, any>[];
}

@Injectable({
  providedIn: 'root'
})
export class ExportToExcelService {
  exportToXls(
    data: Record<string, any>[],
    columnNames: Record<string, string>,
    fileName: string,
    extraColumns?: Record<string, string>
  ): void {
    const keys = Object.keys(columnNames);
    const renamedData = data.map((row) => {
      const renamed: Record<string, any> = {};
      if (extraColumns) {
        Object.entries(extraColumns).forEach(([header, value]) => {
          renamed[header] = value;
        });
      }
      keys.forEach((key) => {
        renamed[columnNames[key]] = row[key] ?? '';
      });
      return renamed;
    });

    const worksheet = XLSX.utils.json_to_sheet(renamedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${fileName}.xlsx`, { bookType: 'xlsx' });
  }
}
